<template>
	<div>
		<v-select
			class="body-1 area-filter"
			color="primary"
			:height="36"
			hide-details
			item-text="name"
			item-value="id"
			:items="subsidiaries"
			outline
			:menu-props="{ contentClass: 'type-select-content' }"
			:style="`color:${$appColors.primary}!important`"
			:value="subsidiarySelected"
			@input="$emit('change-subsidiary', $event)"
		></v-select>
	</div>
</template>

<script>
	export default {
		name: 'subsidiary-filter',
		props: {
			subsidiaries: {
				default: () => [],
				type: Array,
			},
			subsidiarySelected: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/diagnosis/subsidiary-filter.vue